import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Row, Col, Modal, notification } from "antd";
import { updateAirport } from "../../../api/airport.service";

const EditAirportFormModal = ({ fetchAirports, airportData, onClose, isModalOpen, setIsModalOpen, handleOk, handleCancel, isViewOnly = false }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (airportData) {
            form.setFieldsValue({
                airportCode: airportData.airportCode,
                airportName: airportData.airportName, // Ensure it's properly set
            });
        } else {
            form.resetFields();
        }
    }, [airportData, form]);

    const onFinish = async (values) => {
        try {
            await updateAirport(airportData.id, { ...values }); // Ensure ID is sent
            notification.success({ message: "Airport Edited" });
            fetchAirports();
            setIsModalOpen(false);
        } catch (error) {
            notification.error({ message: "Operation failed!" });
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        fetchAirports();
    }, []);

    return (
        <Modal 
            footer={null} 
            destroyOnClose 
            title={`${isViewOnly ? "View" : "Edit"} Airport`} 
            open={isModalOpen} 
            onCancel={handleCancel}
        >
            <Form
                disabled={isViewOnly}
                form={form}
                layout="vertical"
                onFinish={onFinish} 
                initialValues={{ airportName: "", airportCode: "" }} // Ensure default values
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item 
                            label="Airport Name" 
                            name="airportName" 
                            rules={[{ required: true, message: "Please enter airport name" }]}
                        >
                            <Input placeholder="Enter airport name" />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                    <Form.Item 
                            label="Airport Code" 
                            name="airportCode" 
                            rules={[{ required: true, message: "Please enter airport code" }]}
                        >
                            <Input placeholder="Enter airport code" />
                        </Form.Item>
                    </Col>
                </Row>
                {!isViewOnly && (
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                )}
            </Form>
        </Modal>
    );
};

export default EditAirportFormModal;
